import React from "react";
import RuTableRow from "./RuTableRow";

/**
 * Reusable, flexible table component.
 * Supports string or object-based column and field definitions.
 *
 * @param {Array} columns - Column headers (string or { name, align }).
 * @param {Array} data - Table data.
 * @param {Array} fields - Field names (string or { field, align }).
 * @param {Function} [renderActions] - Optional custom action renderer.
 * @param {String} [tableClass="table table-hover"] - Table class.
 */
const RuTable = ({
  columns = [],
  data = [],
  fields = [],
  renderActions,
  tableClass = "table table-hover",
}) => {
  return (
    <div className="table-responsive" id="slimtest2">
      <table className={tableClass} id="filter_date">
        <thead>
          <tr>
            {columns.map((col, idx) => {
              const colName = typeof col === "string" ? col : col.name;
              const alignClass =
                typeof col === "object" && col.align
                  ? `text-${col.align}`
                  : "text-center";

              return (
                <th key={idx} className={alignClass}>
                  {colName}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {data.length > 0 ? (
            data.map((item, index) => (
              <RuTableRow
                key={item._id || index}
                index={index}
                item={item}
                columns={columns}
                fields={fields}
                renderActions={renderActions}
              />
            ))
          ) : (
            <tr>
              <td colSpan={columns.length} className="text-center text-muted">
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default RuTable;
